import facebookIcon from '@/assets/Facebook-weiss.svg';
import instagramIcon from '@/assets/Instagram-weiss.svg';
import linkedInIcon from '@/assets/LinkedIn-weiss.svg';
import merzLogo from '@/assets/Logo-Merz-Dental.svg';
import youtubeIcon from '@/assets/YouTube-weiss.svg';
import { useTranslations } from '@/i18n/client';

const FOOTER_LINKS = {
  facebook: 'https://www.facebook.com/MerzDentalDeutschland',
  instagram: 'https://www.instagram.com/merzdental_de/',
  linkedin: 'https://de.linkedin.com/company/merzdental',
  youtube: 'https://www.youtube.com/@MerzDentalGmbH',
  privacy: 'https://www.merz-dental.de/datenschutz',
  terms: 'https://www.merz-dental.de/agb',
  imprint: 'https://www.merz-dental.de/impressum',
} as const;

function ExternalLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="max-sm:inline-flex max-sm:min-h-11 max-sm:min-w-11 max-sm:items-center max-sm:justify-center"
    >
      {children}
    </a>
  );
}

export function AppFooter() {
  const t = useTranslations('common');

  return (
    <footer className="md-footer mt-10 h-[180px] shrink-0 basis-[180px] max-sm:h-auto max-sm:min-h-[180px] max-sm:basis-auto">
      <div className="box-border mx-auto flex h-full w-[calc(100%-3rem)] max-w-[var(--zs-container-width)] items-start justify-between gap-8 pt-4 max-sm:h-auto max-sm:min-h-[180px] max-sm:flex-col max-sm:items-start max-sm:justify-center max-sm:gap-5 max-sm:pb-4">
        <div className="flex flex-col items-start gap-[0.65rem]">
          <img src={merzLogo} alt={t('app.name')} className="block h-14 w-auto" />
          <p className="m-0 text-xs leading-[1.4] text-[var(--md-footer-text)]">{t('footer.copyright')}</p>
          <p className="m-0 text-xs leading-[1.4] text-[var(--md-footer-text)]">{t('footer.cookieNotice')}</p>
        </div>

        <div className="flex flex-col items-end gap-4 max-sm:w-full max-sm:items-start max-sm:gap-6">
          <nav aria-label={t('footer.legalNavigation')}>
            <ul className="m-0 flex list-none items-center gap-4 p-0 max-sm:flex-wrap max-sm:gap-x-[0.85rem] max-sm:gap-y-[0.35rem]">
              <li>
                <ExternalLink href={FOOTER_LINKS.imprint}>{t('footer.imprint')}</ExternalLink>
              </li>
              <li>
                <ExternalLink href={FOOTER_LINKS.privacy}>{t('footer.privacy')}</ExternalLink>
              </li>
              <li>
                <ExternalLink href={FOOTER_LINKS.terms}>{t('footer.terms')}</ExternalLink>
              </li>
            </ul>
          </nav>

          <nav aria-label={t('footer.socialNavigation')}>
            <ul className="m-0 flex list-none flex-wrap items-center gap-4 p-0">
              <li>
                <ExternalLink href={FOOTER_LINKS.facebook}>
                  <img
                    src={facebookIcon}
                    alt=""
                    className="relative inline-flex h-[30px] w-[30px] shrink-0 items-center justify-center object-contain text-[var(--md-footer-text)]"
                    aria-hidden="true"
                  />
                  <span className="sr-only">{t('footer.facebook')}</span>
                </ExternalLink>
              </li>
              <li>
                <ExternalLink href={FOOTER_LINKS.instagram}>
                  <img
                    src={instagramIcon}
                    alt=""
                    className="relative inline-flex h-[30px] w-[30px] shrink-0 items-center justify-center object-contain text-[var(--md-footer-text)]"
                    aria-hidden="true"
                  />
                  <span className="sr-only">{t('footer.instagram')}</span>
                </ExternalLink>
              </li>
              <li>
                <ExternalLink href={FOOTER_LINKS.linkedin}>
                  <img
                    src={linkedInIcon}
                    alt=""
                    className="relative inline-flex h-[30px] w-[30px] shrink-0 items-center justify-center object-contain text-[var(--md-footer-text)]"
                    aria-hidden="true"
                  />
                  <span className="sr-only">{t('footer.linkedin')}</span>
                </ExternalLink>
              </li>
              <li>
                <ExternalLink href={FOOTER_LINKS.youtube}>
                  <img
                    src={youtubeIcon}
                    alt=""
                    className="relative inline-flex h-[30px] w-[30px] shrink-0 items-center justify-center object-contain text-[var(--md-footer-text)]"
                    aria-hidden="true"
                  />
                  <span className="sr-only">{t('footer.youtube')}</span>
                </ExternalLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}
